<section class="tile-flat site-card">
  <header class="tile-flat__header">
    <div class="site-card__head">
      <div class="site-card__head-left">
        <nb-icon icon="link-2-outline" class="site-card__icon"></nb-icon>
        <div class="site-card__title">
          <h5 class="site-card__name">{{ registration.display_name }}</h5>
          <span class="site-card__url">{{ issuerHost() }}</span>
        </div>
      </div>
      <div class="site-card__head-right">
        <span class="site-card__count">
          {{ placements.length }} {{ 'pages.tutors.placements.lti.count' | translate }}
        </span>
        <!-- Ghost statt primary: der Normalfall ist Deep Linking im LMS, nicht
             das Abtippen einer Kontext-ID. Diese Schaltfläche ist der
             Rückfallweg für LMS ohne Deep-Linking-Unterstützung. -->
        <button
          nbButton
          ghost
          status="basic"
          size="small"
          [nbTooltip]="'pages.tutors.placements.lti.addTooltip' | translate"
          nbTooltipPlacement="top"
          (click)="openCreate()"
        >
          <nb-icon icon="plus-outline"></nb-icon>
          {{ 'pages.tutors.placements.lti.add' | translate }}
        </button>
      </div>
    </div>
  </header>

  <p class="site-card__hint">{{ 'pages.tutors.placements.lti.cardHint' | translate }}</p>

  <!-- Der automatische Weg zuerst und sichtbar, sonst wirkt das manuelle
       Formular wie der vorgesehene Ablauf. -->
  <div class="auto-hint">
    <nb-icon icon="checkmark-circle-2-outline" status="success"></nb-icon>
    <div>
      <strong>{{ 'pages.tutors.placements.lti.autoTitle' | translate }}</strong>
      <p>{{ 'pages.tutors.placements.lti.autoBody' | translate }}</p>
    </div>
  </div>

  <div *ngIf="loading" class="site-card__loading">
    <nb-spinner status="basic"></nb-spinner>
  </div>

  <div *ngIf="!loading && placements.length === 0" class="site-card__empty">
    <p>{{ 'pages.tutors.placements.lti.empty' | translate }}</p>
  </div>

  <table *ngIf="!loading && placements.length > 0" class="site-card__table">
    <colgroup>
      <col class="col-context" />
      <col class="col-course" />
      <col class="col-agent" />
      <col class="col-actions" />
    </colgroup>
    <thead>
      <tr>
        <th
          [nbTooltip]="'pages.tutors.placements.lti.col.contextTooltip' | translate"
          nbTooltipPlacement="top"
        >
          {{ 'pages.tutors.placements.lti.col.context' | translate }}
          <nb-icon icon="info-outline" class="col-info"></nb-icon>
        </th>
        <th
          [nbTooltip]="'pages.tutors.placements.lti.col.courseTooltip' | translate"
          nbTooltipPlacement="top"
        >
          {{ 'pages.tutors.placements.lti.col.course' | translate }}
          <nb-icon icon="info-outline" class="col-info"></nb-icon>
        </th>
        <th
          [nbTooltip]="'pages.tutors.placements.lti.col.agentTooltip' | translate"
          nbTooltipPlacement="top"
        >
          {{ 'pages.tutors.placements.lti.col.agent' | translate }}
          <nb-icon icon="info-outline" class="col-info"></nb-icon>
        </th>
        <th></th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let p of placements; trackBy: trackPlacement">
        <td>
          <span class="lti-context">{{ p.lti_context_id }}</span>
          <span class="lti-scope" [class.lti-scope--activity]="!!p.lti_resource_link_id">
            <ng-container *ngIf="p.lti_resource_link_id; else courseWide">
              {{ 'pages.tutors.placements.lti.activity' | translate }} · {{ p.lti_resource_link_id }}
            </ng-container>
            <ng-template #courseWide>{{ 'pages.tutors.placements.lti.courseWide' | translate }}</ng-template>
          </span>
        </td>
        <td>
          <ng-container *ngIf="courseName(p.course_id) as name; else noCourse">{{ name }}</ng-container>
          <ng-template #noCourse>
            <span class="muted">{{ 'pages.tutors.placements.lti.noCourse' | translate }}</span>
          </ng-template>
        </td>
        <td>
          <ng-container *ngIf="tutorName(p.bot_id) as name; else noAgent">{{ name }}</ng-container>
          <ng-template #noAgent>
            <span class="warn">{{ 'pages.tutors.placements.lti.noAgent' | translate }}</span>
          </ng-template>
        </td>
        <td class="cell-actions">
          <button
            nbButton
            ghost
            size="small"
            status="primary"
            [attr.aria-label]="'buttons.edit' | translate"
            (click)="openEdit(p)"
          >
            <nb-icon icon="edit-2-outline"></nb-icon>
          </button>
          <button
            nbButton
            ghost
            size="small"
            status="danger"
            [attr.aria-label]="'buttons.delete' | translate"
            (click)="remove(p)"
          >
            <nb-icon icon="trash-2-outline"></nb-icon>
          </button>
        </td>
      </tr>
    </tbody>
  </table>
</section>
